import { post } from '@ubeya/shared/utils/http';

export const createAccount = (params) => post('/admin/signup', params);

export const sendCode = ({ email, code }) => post('/admin/login', { email, password: code, type: 'code' });

export const resendEmail = ({ email }) => post('/admin/login/code', { email });
